export default __webpack_public_path__ + "static/media/DSC30006.2044b9c3.jpg";